/**
 * App-wide singleton `authFetch` for any apps/auth code that needs a raw
 * `typeof fetch` (PAT management, file bulk ops, etc.) — anything not on the
 * generated `Api` client.
 *
 * Thin wrapper over `createAuthFetch` from `@workspace/network` so we don't
 * reinvent the refresh + dedup + queueing logic. Sharing a single instance
 * across the app means concurrent 401s coalesce into a single `/v1/refresh`
 * rather than fanning out.
 *
 * The generated `Api` client at `./api-client.ts` uses this same fetch via
 * `customFetch` so all auth-API traffic shares the same dedup state.
 */

import {
  DEFAULT_NO_REFRESH_PATHS,
} from "@workspace/auth-client";
import { createAuthFetch } from "@workspace/network";

const authApiUrl = process.env.NEXT_PUBLIC_API_URL || "";

export const authFetch = createAuthFetch({
  authApiUrl,
  noRefreshPaths: DEFAULT_NO_REFRESH_PATHS,
});
